import { jsx as _jsx } from "react/jsx-runtime";
import { useClientFieldsOfStudy } from '@src/hooks/useClientFieldsOfStudy';
import { MuiMultiSelect, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
export const FieldOfStudyPolicy = ({ clientId, policy, onChange, readonly, }) => {
    const { t } = useLocale();
    const { clientFieldsOfStudy } = useClientFieldsOfStudy({ clientId, initialPageSize: 1000 });
    const fieldOfStudyOptions = useMemo(() => {
        return (clientFieldsOfStudy || []).map((cfs) => ({
            value: cfs.fieldOfStudyId.toString(),
            label: cfs.fieldOfStudy?.name ?? t('N/A'),
        }));
    }, [clientFieldsOfStudy]);
    const handleOnChange = (event) => {
        onChange({
            ...policy,
            fieldOfStudies: event.selection?.map(x => x.value) ?? undefined,
        });
    };
    return (_jsx("div", { className: 'flex flex-col gap-2', children: _jsx(MuiMultiSelect, { disabled: readonly, label: t('Allowed Fields of Study'), onChange: handleOnChange, options: fieldOfStudyOptions, value: policy.fieldOfStudies ?? [] }) }));
};
